import {globalStore} from './redux.Interface.Store'
import {createAction} from './redux.Interface.Reducer'
import {GlobalFeatureNameSpaceNotary} from './globalNotary'
import { fetchUserDetails } from '../v2/store/users/user.actions';
import { fetchGoogleImagePull } from '../v2/store/settings';

const sessionCookieName = 'dk_' + window.location.host
const createCookie = (cookieName, cookieValue, secondsToExpire, path) => {
  const date = new Date()
  date.setTime(date.getTime() + secondsToExpire * 1000)

  if (path)
  {
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + date.toGMTString() + '; path=' + path
  }else
  {
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + date.toGMTString()
  }
}

const readCookie = (name) => {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

const checkMarks = () => {
  let accessToken = window.localStorage.getItem('token')

  if (accessToken === null)
  {
    let url = window.location.href
    if (url.includes('token'))
    {
      accessToken = url.split('=')[1]
      establishOrRefreshSession(true)
    }
  }

  const sessionCookie = readCookie(sessionCookieName)

  if (sessionCookie === null)
  {
    console.log('The Session Cookie is null')
  }

 return ((accessToken) && (sessionCookie))


}
export const checkSession = () => {
  if (!checkMarks()) {
    destroySession();
    globalStore.dispatch(createAction(GlobalFeatureNameSpaceNotary.SIGNIN_SIGNOUT, 'signOut')());
    console.log('Check session is attempting to log out the user');
  }

  if (!globalStore.getState()?.users?.isUserDataSet) {
    globalStore.dispatch(fetchUserDetails());
  }

  if (globalStore.getState()?.settings?.isGoogleImagePull === null) {
    globalStore.dispatch(fetchGoogleImagePull());
  }
};

export const Authenticate = (component) => {

    if (checkMarks()) {
      return component
    } else {
      return () => {
        window.location.replace('/login')
      }
    }
  }

  export const establishOrRefreshSession = (defaultPath) => {
    if (defaultPath)
    {
      createCookie(sessionCookieName, 'User_Session', 7200, '/')
    }else
    {
      createCookie(sessionCookieName, 'User_Session', 7200)
    }
  }

  export const destroySession = () => {

    createCookie(sessionCookieName, '', -1)
  }




